import FileManagementSidebar from "./FileManagementSidebar";
import PackageManagementSidebar from "./PackageManagementSidebar";
import ProjectManagementSidebar from "./ProjectManagementSidebar";
import StudyManagementSidebar from "./StudyManagementSidebar";

function LUPManagementSidebar({
  collapseSidebar,
  checkActiveTab,
  openModule,
  onMouseDown,
  tableRef,
  handleAddNewTab,
  checkActiveTabData,
  setFileFolderUpdater,
  fileFolderUpdater,
  handleDeleteTab
}) {
  return (
    <>
      {openModule === "lupProject" && (
        <ProjectManagementSidebar
          collapseSidebar={collapseSidebar}
          onMouseDown={onMouseDown}
          tableRef={tableRef}
          handleAddNewTab={handleAddNewTab}
          checkActiveTabData={checkActiveTabData}
        />
      )}
      {openModule === "lupStudy" && (
        <StudyManagementSidebar
          collapseSidebar={collapseSidebar}
          checkActiveTab={checkActiveTab}
          handleAddNewTab={handleAddNewTab}
        />
      )}
      {openModule === "lupPackage" && (
        <PackageManagementSidebar
          collapseSidebar={collapseSidebar}
          checkActiveTabData={checkActiveTabData}
          handleAddNewTab={handleAddNewTab}
          openModule={openModule}
        />
      )}
      {openModule === "lupFile" && (
        <FileManagementSidebar
          collapseSidebar={collapseSidebar}
          checkActiveTabData={checkActiveTabData}
          handleAddNewTab={handleAddNewTab}
          openModule={openModule}
          setFileFolderUpdater={setFileFolderUpdater}
          fileFolderUpdater={fileFolderUpdater}
          handleDeleteTab={handleDeleteTab}
        />
      )}
    </>
  );
}

export default LUPManagementSidebar;